import { combineReducers } from 'redux';
import { systemReducer } from './system/reducers';
import { chatReducer } from './chat/reducers';
import { identityReducer } from './identity/reducers';
import { riskModelReducer } from './newRiskModel/reducers';
import { previewMediaReducer } from './previewMedia/reducers';
import { userReducer } from './user/reducers';
import { filtersReducer } from './filters/reducers';
import { breadcrumbsReducer } from './breadCrumbs/reducers';
import { chipsReducer } from './chips/reducers';
export const rootReducer = combineReducers({
    system: systemReducer,
    chat: chatReducer,
    identity: identityReducer,
    newRiskModel: riskModelReducer,
    breadcrumbs: breadcrumbsReducer,
    previewMedia: previewMediaReducer,
    user: userReducer,
    filters: filtersReducer,
    chips: chipsReducer,
});
export function createReducer() {
    return rootReducer;
}
